import { NavButton } from "../atoms/buttons"
import { useContext } from "react"
import { UserContext } from "../App"

export function TopNavSetting({settings,active,onClick}){
    const userContext = useContext(UserContext)
    return(
        <div className="horizontal card-background-color standard-rounded" style={{width:"unset", overflowX:"auto", padding:".5rem 0 2rem 0", overflowY:"hidden",}}>
            {settings.map((setting,index) => {
                if (setting.permission && !userContext.permissions.includes(setting.permission)) {
                    return;
                }
                return(
                    <NavButton 
                        onClick={() => onClick(setting.SettingID)}
                        active={setting.SettingID === active}
                        key={setting.SettingID} 
                        title={setting.Setting}
                        
                    />
                )
            })}
        </div>
    )
}